import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Car } from 'lucide-react';
import { useT } from '../services/i18n';
import { productsAPI } from '../services/api';

// Category / subcategory page: links to the most requested vehicle models fitted by these parts
export const PopularModelsBlock = ({ category, sub }) => {
  const { t, lang } = useT();
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    setData(null);
    if (!category) return undefined;
    productsAPI.popularModels(category, sub, lang).then((d) => alive && setData(d)).catch(() => alive && setData({ items: [] }));
    return () => { alive = false; };
  }, [category, sub, lang]);
  if (!data?.items?.length) return null;
  return (
    <section className="bg-white rounded-xl shadow-sm p-6 mt-8" data-testid="popular-models">
      <h2 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2"><Car size={18} className="text-orange-500" /> {t('cat.popularModels', { part: data.part })}</h2>
      <ul className="flex flex-wrap gap-2">
        {data.items.map((m, i) => (
          <li key={m.path}>
            <Link to={m.path} data-testid={`popular-model-${i}`} title={t('cat.nProducts', { n: m.products, count: m.products })} className="inline-flex items-center gap-1 text-sm px-3 py-1.5 rounded-full border border-gray-200 text-gray-700 hover:border-orange-400 hover:text-orange-600 transition-colors">
              {m.label}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
};
